<unity-outside-container modalHeaderTitle="Setup" modalHeaderSubtitle="Account">
  <kendo-stacklayout orientation="vertical" class="outside-form" [gap]="detailCardGridLayoutGap.rows!">
    @let success = $confirmUser();
    @if (confirmUserResource.isLoading() === true) {
      <kendo-loader size="large" />
    }
    @let error = $error()?.message;
    @let invalidToken = $invalidToken();

    @if (invalidToken === true) {
      <p>There was an issue confirming your email address.</p>
      <button kendoButton themeColor="tertiary" routerLink="/resend-confirm" type="button">Request New Confirmation Email</button>
    } @else if (error && error.length > 0) {
      <p>Error: {{ error }}</p>
    } @else if (success === true) {
      <p>Your email address has been confirmed!</p>
    }

    <button kendoButton themeColor="primary" type="button" [routerLink]="['/login']">Go to Login</button>
  </kendo-stacklayout>
</unity-outside-container>
